import React from "react";
import { Box, Button, Typography } from "@mui/material";

const emojiPalette = {
  Halloween: ["🎃", "👻", "🕸️", "🧛"],
  Noël: ["🎄", "🎅", "❄️", "⛄"],
  Anniversaire: ["🎂", "🎉", "🎈", "🥳"],
  Musique: ["🎶", "🎸", "🎤", "🥁"],
  Autres: ["🌿", "📚", "❤️", "✨", "🤝", "😊", "😎", "🌸"]
};

export const allEmojis = Object.values(emojiPalette).flat();

const EmojiPicker = ({ onSelect }) => {
return (
  <Box sx={{ mt: 1 }}>
    {Object.entries(emojiPalette).map(([category, emojis]) => (
      <Box key={category} sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
          {category}
        </Typography>
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {emojis.map((emoji) => (
            <Button
              key={emoji}
              onClick={() => onSelect(emoji)}
              sx={{ fontSize: "1.5rem", minWidth: "2.5rem", padding: 0 }}
            >
              {emoji}
            </Button>
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);

};

export default EmojiPicker;
